
import { ClientDetails } from 'src/app/site/feature-modules/profile/models/profile';

export class ClientDetailsImpl implements ClientDetails {
    basicInfo: { 
        countryCode: string; 
        name: string; 
        email: null | string; 
        mobile: string; 
        birthDate: null | string; 
        gender: number; 
        imageName?: string; 
        imagePath?: string; 
    };
    additionalInfo: {
        mobile: string;
        perferdEmplyee: null | string;
        source: null | string;
        clientInfo: null | string;
    };
    addresses: { 
        street: string; 
        city: string; 
        zipCode: string; 
    } | undefined;
    clientAddress: any[];

    constructor(data: Partial<ClientDetails> = {}) {
        this.basicInfo = {
            countryCode: data.basicInfo?.countryCode || 'SA',
            name: data.basicInfo?.name || '',
            email: data.basicInfo?.email || '',
            mobile: data.basicInfo?.mobile || '',
            birthDate: data.basicInfo?.birthDate || '',
            gender: data.basicInfo?.gender || 0,
            imageName: data.basicInfo?.imageName || '',
            imagePath: data.basicInfo?.imagePath || ''
        };

        this.additionalInfo = {
            mobile: data.additionalInfo?.mobile || '',
            perferdEmplyee: data.additionalInfo?.perferdEmplyee || '',
            source: data.additionalInfo?.source || '',
            clientInfo: data.additionalInfo?.clientInfo || ''
        };

        this.addresses = data.addresses || { street: '', city: '', zipCode: '' };

        this.clientAddress = data.clientaddress || [];

    }
    clientaddress: any[];
}
